<template>
  <div class="Captcha">
    <Verify
      ref="verify"
      :captcha-type="'blockPuzzle'"
      :img-size="{ width, height }"
      :mode="'pop'"
      :show="show"
      :with-credentials="withCredentials"
      @success="success"
      @close="close"
    />
  </div>
</template>

<script>
// import BScroll from "@better-scroll/core";
import Verify from "./verify/Verify";
export default {
  name: "Captcha",
  components: {
    Verify,
  },
  data() {
    return {
      show: this.show || false,
      withCredentials: this.$options.withCredentials,
    };
  },
  computed: {
    width() {
      let width = document.body.clientWidth * 0.8;
      if (width > 330) width = 330;
      return width + "px";
    },
    height() {
      const WHRate = 330 / 155;
      const width = document.body.clientWidth * 0.8;
      let height = width / WHRate;
      if (height > 155) height = 155;
      return height + "px";
    },
  },
  mounted() {
    // const bs = new BScroll(".Captcha");
  },
  methods: {
    // params 返回的二次验证参数, 和登录参数一起回传给登录接口，方便后台进行二次验证
    success(params) {
      this.$emit("success", params);
      this.$destroy();
    },
    close() {
      this.$emit("close");
      this.$destroy();
    },
  },
};
</script>
